import { render, staticRenderFns } from "./CGU.vue?vue&type=template&id=1dfe7bbd&scoped=true&"
import script from "./CGU.vue?vue&type=script&lang=ts&"
export * from "./CGU.vue?vue&type=script&lang=ts&"
import style0 from "./CGU.vue?vue&type=style&index=0&id=1dfe7bbd&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dfe7bbd",
  null
  
)

export default component.exports